/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';


interface BatchInformationSectionProps {
  batchDetails?: any;
  powderBatchDetails?: any;
  onViewLotDetails?: (lotId: string) => void;
}

const BatchInformationSection: React.FC<BatchInformationSectionProps> = ({
  batchDetails,
  onViewLotDetails,
  powderBatchDetails
}) => {
  const { t } = useTranslation();
  const batch = batchDetails?.media_batch_identifier || "-";
  const leadTechnicianId = batchDetails?.lead_technician_id || "-";
  const createdDate = batchDetails?.created_at?.split(" ")[0] || "-";
  const createdTime = batchDetails?.created_at?.split(" ")[1] || "-";
  const finalVolume = batchDetails?.dispensing_summary?.total_dispensed_volume_ml || "-";

  return (
    <div className="space-y-4">
        <section className="bg-white border border-slate-200 rounded-lg overflow-hidden">
              <div className="px-8 py-2 border-b-2 border-slate-900 flex items-center justify-between bg-slate-900 text-white">
                <div className="flex items-center gap-4">
                  <div className="w-6 h-6 rounded-sm bg-slate-900 text-white flex items-center justify-center font-black text-[10px]">01</div>
                  <h3 className="text-[10.5px] font-black uppercase tracking-[0.2em] mt-[7px]">{t('mediaPrepBatch.mediaPrepBatchDetails.batchInfo')}</h3>
                </div>              
              </div>
              <div className="px-6 py-6 flex items-start">
                <div className="space-y-4">
                  <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">{t('mediaPrepBatch.tableColumns.batch_id')}</p>
                  {/* <div className="flex items-center gap-4 p-3 bg-slate-50 border border-slate-100 rounded-xl"> */}
                    {/* <div className="w-12 h-12 rounded-full bg-slate-900 text-white flex items-center justify-center font-black text-sm border-2 border-orange-500">SM</div> */}
                    <div>
                      <p className="text-sm font-black text-slate-900">{batch}</p>
                      {/* <p className="text-[10px] font-bold text-slate-400 uppercase">ID: {leadTechnicianId}</p> */}
                    </div>
                  {/* </div> */}
                </div>
                <div className="mx-16 w-px h-16 bg-slate-300"></div>
                <div className="space-y-4">
                  <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">{t('mediaPrepBatch.mediaPrepBatchDetails.Timestamp')}</p>
                  <div className="space-y-1">
                    <p className="text-sm font-black text-slate-900 font-mono tracking-tighter">{createdDate}</p>
                    <p className="text-sm font-black text-slate-900 font-mono tracking-tighter">{createdTime}</p>
                  </div>
                </div>
                <div className="mx-16 w-px h-16 bg-slate-300"></div>
                <div className="space-y-4">
                  <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">{t('mediaPrepBatch.mediaPrepBatchDetails.BatchVolumne')}</p>
                  <div className="relative">
                    <p className="text-sm font-black text-slate-900 leading-relaxed">
                      {finalVolume} mL
                    </p>
                  </div>
                </div>
              </div>
            </section>



            {/* 2. Lot Details */}
            <section className="bg-white border border-slate-200 rounded-lg overflow-hidden">
              <div className="px-8 py-2 border-b-2 border-slate-900 flex items-center justify-between bg-slate-50"
                 style={{borderBottom: "1px solid #e2e8f0",}}
              >
                <div className="flex items-center gap-4">
                  <div className="w-6 h-6 rounded-sm bg-slate-900 text-white flex items-center justify-center font-black text-[10px]">02</div>
                  <h3 className="text-[11.5px] font-black uppercase tracking-[0.08em] text-slate-900 mt-[7px]">{t('mediaPrepBatch.mediaPrepBatchDetails.lotDetails')}</h3>
                </div>
                <button 
                  onClick={() => onViewLotDetails?.(powderBatchDetails?.id)}
                  className="px-3 py-1.5 rounded-sm bg-slate-900 text-white text-[9px] font-black uppercase tracking-widest border-0 shadow-none ring-0 outline-none"
                >
                  {t('mediaPrepBatch.mediaPrepBatchDetails.InspectLot')}
                </button>
              </div>
                <div className="px-6 py-4 flex items-start gap-2.5">
                  <div className="space-y-4">
                    <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">{t('mediaPrepBatch.mediaPrepBatchDetails.ProductName')}</p>
                    <p className="text-sm font-black text-slate-900">{powderBatchDetails?.media_name || "-"}</p>
                  </div>
                  <div className="mx-4 w-px h-14 bg-slate-300"></div>
                  <div className="space-y-1">
                    <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">{t('mediaPrepBatch.mediaPrepBatchDetails.Manufacturer')}</p>
                    <p className="text-sm font-black text-slate-900">{powderBatchDetails?.manufacturer_name || "-"}</p>
                  </div>
                  <div className="mx-4 w-px h-14 bg-slate-300"></div>
                  <div className="space-y-1">
                    <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">{t('mediaPrepBatch.mediaPrepBatchDetails.CatalogNumber')}</p>
                    <p className="text-sm font-mono font-black text-slate-900">{powderBatchDetails?.catalog_number || "-"}</p>
                  </div>
                  <div className="mx-4 w-px h-14 bg-slate-300"></div>
                  <div className="space-y-2 bg-red-50 px-3 py-2 self-start">
                    <p className="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em]">{t('mediaPrepBatch.mediaPrepBatchDetails.ExpiryDate')}</p>
                    <p className="text-sm font-bold text-red-600 font-mono">{powderBatchDetails?.expiry_date || "-"}</p>
                  </div>
                </div>
            </section>
    </div>
    );
};

export default BatchInformationSection;